/* eslint-disable no-unused-vars */
import type { UAPStyleMap } from '../../@types';

const WideImage4x1ZoomPercent = 0.625;
const LandscapeImage191x100ZoomPercent = 0.81;


export const getPMaxPlacementBaseStyles = (_theme: object, zoomPercent = 1): UAPStyleMap => ({
  // { },

  placementImageContainer: undefined,

  placementTextContainer: {
    position: 'absolute',
    left: 0,
    bottom: 25 * zoomPercent,
    paddingLeft: 32 * zoomPercent,
    fontSize: 10 * zoomPercent,
    lineHeight: 1.1 * zoomPercent,
  },

  // { },

  placementAdsLabel: undefined,

  placementGradient: {
    backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
  },

  placementShortHeadline: {
    position: 'relative',
    bottom: 20 * zoomPercent,
    paddingBottom: 5 * zoomPercent,
    fontWeight: '200',
    fontSize: 24 * zoomPercent,
    color: 'white',
  },

  placementLongHeadline: {
    position: 'relative',
    bottom: 15 * zoomPercent,
    paddingBottom: 5 * zoomPercent,
    fontWeight: '200',
    fontSize: 24 * zoomPercent,
    color: 'white',
  },

  placementFinalUrl: {
    color: 'white',
    bottom: 10 * zoomPercent,
    position: 'relative',
    fontSize: 10 * zoomPercent,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  placementDescription: {
    color: 'white',
    bottom: 5 * zoomPercent,
    position: 'relative',
    fontSize: 14 * zoomPercent,
  },

  placementCallToAction: {
    position: 'relative',
    borderRadius: 32 * zoomPercent,
    border: 'none',
    // padding: '7px 16px 8px 16px',
    padding: `${7 * zoomPercent}px ${16 * zoomPercent}px ${8 * zoomPercent}px ${16 * zoomPercent}px`,
    fontSize: 16 * zoomPercent,
    color: '#666',
    backgroundColor: '#EEE',
    opacity: '70%',
    fontWeight: 'bold',
  },
});

export const getPMaxV2PlacementBaseStyles = (_theme?: object): UAPStyleMap => ({
  placementCard: {
    border: '1px solid #c8c8c8',
    boxShadow: 'unset !important',
    borderRadius: '0px !important',
  },

  placementImageContainer: undefined,

  placementTextContainer: undefined,

  placementAdsLabel: undefined,

  placementGradient: undefined,

  placementShortHeadline: undefined,

  placementLongHeadline: undefined,

  placementFinalUrl: undefined,

  placementDescription: undefined,

  placementCallToAction: undefined,

  placementBusinessNameWithAdsLabel: undefined,
});


export const getPMaxMSNCarousel169x100Styles = (theme: object) => {
  const baseStyles = getPMaxV2PlacementBaseStyles(theme);

  return {
    placementCard: {
      ...baseStyles.placementCard,
      width: '338px !important',
      height: 200,
      borderRadius: '6px !important',
      boxShadow: 'none !important',
    },

    placementImageContainer: {
      width: '100%',
      height: '100%',
      ...baseStyles.placementImageContainer,
    },

    placementTextContainer: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      height: '194px',
      background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.54) 100%)',
    },

    placementInfoContainer: {
      paddingTop: '80px',
      height: '150px',
      boxSizing: 'border-box',
    },

    placementLongHeadline: {
      padding: '0px 16px',
      fontFamily: 'Segoe UI',
      fontWeight: '600',
      fontSize: '28px',
      lineHeight: '35px',
      color: 'rgba(255, 255, 255, 1)',
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': 2, /* Limit to 2 lines */
      overflow: 'hidden',
    },

    businuessAndAdChoiceContainer: {
      height: 44,
      boxSizing: 'border-box',
      padding: '0px 16px',
      display: 'flex',
      alignItems: 'center',
    },

    adsLabelContainerClassName: {
      marginRight: 8,
      height: 16,
    },

    adsLabelClassName: {
      borderColor: 'rgba(255, 255, 255, 0.3) !important',
      color: 'white !important',
    },

    placementBusinessNameContainer: {
      fontFamily: 'Segoe UI',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '16px',
      flexGrow: 1,
      color: 'white',
    },
  };
};


export const getPMaxMicrosoftEdgeCarousel201x100Styles = (theme: object) => {
  // base styles

  const baseStyles = getPMaxV2PlacementBaseStyles(theme);

  return {
    placementCard: {
      ...baseStyles.placementCard,
      borderRadius: '8px !important',
      width: '401px !important',
      height: 200,
    },

    placementTextContainer: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      height: '280px',
    },

    placementGradient: {
      display: 'block',
      width: '100%',
      height: '178px !important',
      background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 50.03%, rgba(30, 30, 30, 0.34) 88.85%, rgba(0, 0, 0, 0.44) 100%)',
    },

    placementInfoContainer: {
      padding: '12px 16px 0px',
      minHeight: '62px',
      boxSizing: 'border-box',
      background: 'linear-gradient(360deg, rgba(0, 0, 0, 0.54) 5.47%, rgba(0, 0, 0, 0.54) 55.63%, rgba(0, 0, 0, 0.49) 78.44%, rgba(0, 0, 0, 0.475) 89.43%, rgba(0, 0, 0, 0.44) 100%)',
    },

    businuessAndLogoContainer: {
      display: 'flex',
      marginBottom: 8,
    },

    placementLogoContainer: {
      height: 16,
      width: 16,
      marginRight: 8,
      '& .cropped-image-view': {
        borderRadius: '2px !important',
        '& img': {
          verticalAlign: 'top',
        },
      },
    },

    placementBusinessNameContainer: {
      fontFamily: 'Segoe UI',
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '16px',
      color: 'white',
    },

    placementShortHeadline: {
      color: 'white',
      fontFamily: 'Segoe UI',
      fontWeight: '600',
      fontSize: '20px',
      lineHeight: '26px',
    },

    businuessAndAdChoiceContainer: {
      height: 40,
      boxSizing: 'border-box',
      padding: '0px 16px',
      display: 'flex',
      alignItems: 'center',
      background: 'var(--backplate-text-backplate-on-image-text-backplate-54451, rgba(0, 0, 0, 0.54))',
    },

    headChoiceIconClassName: {
      marginRight: 8,
    },

    adsLabelContainerClassName: {
      flexGrow: 1,
      height: 16,
    },

    adsLabelClassName: {
      display: 'inline-block',
      verticalAlign: 'top',
      borderColor: 'rgba(255, 255, 255, 0.3) !important',
      color: 'white !important',
    },

    placementCallToAction: {
      border: '1px solid',
      borderImageSource: 'linear-gradient(180deg, rgba(0, 0, 0, 0.0578) 90.58%, rgba(0, 0, 0, 0.1622) 100%)',
      padding: '3px 8px',
      borderRadius: '4px',
      color: 'rgba(255, 255, 255, 1)',
      fontFamily: 'Segoe UI',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '16px',
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
    },

    placementCallToActionAsLink: {
      border: 'none',
      color: 'white',
      fontFamily: 'Segoe UI',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '16px',
      backgroundColor: 'transparent',
    },
  };
};


export const getPMaxMSNWideImage4x1Styles = (theme: object) => ({
  ...getPMaxPlacementBaseStyles(theme, WideImage4x1ZoomPercent),

  // overrides
  placementTextContainer: {
    position: 'absolute',
    left: 0,
    bottom: 15,
    paddingLeft: 20,
    fontSize: 6,
    lineHeight: '10px',
  },

  placementShortHeadline: {
    position: 'relative',
    bottom: 9,
    paddingBottom: 3,
    fontWeight: '200',
    fontSize: 15,
    color: 'white',
  },

  placementAdsLabel: {
    right: 0,
  },

  placementGradient: {
    backgroundImage: 'linear-gradient(to left, transparent 0, black 100%)',
  },
});


export const getPMaxBingSearchLandscapeImage191x100Styles = (theme: object) => ({
  ...getPMaxPlacementBaseStyles(theme, LandscapeImage191x100ZoomPercent),

  // overrides
  placementTextContainer: {
    // padding: `8px 20px 20px 20px',
    padding: `${8 * LandscapeImage191x100ZoomPercent}px ${20 * LandscapeImage191x100ZoomPercent}px ${20 * LandscapeImage191x100ZoomPercent}px ${20 * LandscapeImage191x100ZoomPercent}px`,
    fontSize: 10 * LandscapeImage191x100ZoomPercent,
    lineHeight: 1.1 * LandscapeImage191x100ZoomPercent,
    maxWidth: '-webkit-fill-available',
    '& .logo-and-text-container': {
      display: 'flex',
      flexDirection: 'row',
      paddingBottom: 4 * LandscapeImage191x100ZoomPercent,
      '& .logo-text': {
        display: 'flex',
        flexDirection: 'column',
        '& .logo-business-name': {
          color: '#111',
          fontSize: 14 * LandscapeImage191x100ZoomPercent,
          fontWeight: 400,
          lineHeight: `${18 * LandscapeImage191x100ZoomPercent}px`,
        },
      },
    },
  },

  placementShortHeadline: {
    position: 'relative',
    color: 'black',
    fontSize: 24 * LandscapeImage191x100ZoomPercent,
    marginBottom: 8 * LandscapeImage191x100ZoomPercent,
    fontWeight: '200',
    paddingBottom: 5 * LandscapeImage191x100ZoomPercent,
  },

  placementFinalUrl: {
    position: 'relative',
    color: 'green',
    fontSize: 10 * LandscapeImage191x100ZoomPercent,
    marginBottom: 8 * LandscapeImage191x100ZoomPercent,
  },

  placementDescription: {
    position: 'relative',
    color: 'black',
    fontSize: 14 * LandscapeImage191x100ZoomPercent,
    maxWidth: 250 * LandscapeImage191x100ZoomPercent,
    wordWrap: 'break-word',
    paddingRight: 16 * LandscapeImage191x100ZoomPercent,
  },

  placementCallToAction: {
    color: 'white',
    right: 15 * LandscapeImage191x100ZoomPercent,
    border: 'none',
    bottom: 15 * LandscapeImage191x100ZoomPercent,
    opacity: '90%',
    padding: `${6 * LandscapeImage191x100ZoomPercent}px ${16 * LandscapeImage191x100ZoomPercent}px ${8 * LandscapeImage191x100ZoomPercent}px ${16 * LandscapeImage191x100ZoomPercent}px`,
    position: 'absolute',
    fontSize: 16 * LandscapeImage191x100ZoomPercent,
    fontWeight: 'bold',
    borderRadius: 32,
    backgroundColor: '#a19f9d',
  },

  placementLogoContainer: {
    paddingTop: 4 * LandscapeImage191x100ZoomPercent,
    paddingRight: 6 * LandscapeImage191x100ZoomPercent,
    '& .cropped-image-view': {
      borderRadius: 6,
      border: 'solid 1px #ECECEC',
    },
  },
});
